import  { Dependent } from './dependent';
import  { StudentCourse } from './studentcourse';
import  { StudentPayment } from './studentpayment';
import  { StudentRefund } from './studentrefund';
import  { StudentCoupon } from './studentcoupon';
import  { StudentLeave } from './studentleave';
import  { StudentCredit } from './studentcredit';
import  { ScholarshipAppl } from './scholarshipappl';
import  { StudentCard } from './studentcard';
import  { StudentSpecArea } from './studentspecarea';
import  { StudentWeeklySchedule } from './studentweeklyschedule';
import  { StudentTeacherPref } from './studentteacherpref';
import  { StudentDonation } from './studentdonation';
import  { StudentTransferHistory } from './studenttransferhistory';
import  { Contact } from '../../common/model/contact';
import  { AuthUser } from '../../common/model/authuser';
import  { PlaceOfOrigin } from '../../common/model/placeoforigin';
import  { Gender } from '../../common/model/gender';
import  { Profession } from '../../common/model/profession';
import  { HighestEducation } from '../../common/model/highesteducation';
import  { HearingSource } from '../../common/model/hearingsource';
import  { StudentStatus } from '../../common/model/studentstatus';
import  { AgeGroup } from '../../common/model/agegroup';
import  { BestFor } from '../../common/model/bestfor';
import  { StudentInfo } from './studentinfo';

export class Student {

        public static readonly className:string = "com.tanzeel.student.vo.StudentVO";

        constructor(){}

        id: number;
        fullName: string;
        firstName: string;
        middleName: string;
        lastName: string;
        contact: Contact;
        user: AuthUser;
        placeOfOrigin: PlaceOfOrigin;
        gender: Gender;
        dob: any;
        studentId: string;
        parentStudentId: number;
        picture: string;
        isBeginner: boolean;
        studentSince: any;
        discontinuedOn: any;
        marketingNotes: string;
        spritualGoal: string;
        profession: Profession;
        highestEducation: HighestEducation;
        languagesComfortable: string;
        howDidYouHear: HearingSource;
        studentStatus: StudentStatus;
        userLocation: string;
        ageGroup: AgeGroup;
        readingFluency: BestFor;
        additionalInfo: StudentInfo;
        isScholarship: boolean;
        miscCode: string;
        tempTimeField: any;
        version: number;
        lastPaymentId: string;
        delete: boolean;

}
